<template>
    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
 

<h3 style="text-align: left;">Escoger tipo de representante</h3>
<div class=" py-3 button-group" style="text-align: left;">
    <button :disabled="isButton2Disabled" @click="selectButton(1)" class="btn" style="background-color: #F49315; color: white;">Persona Fisica</button>
    <button :disabled="isButton1Disabled" @click="selectButton(2)" class="btn" style="background-color: #F49315; color: white;">Persona Moral</button>
</div>
<div style="display:none" id="personaMoral">
    <div class="py-3 col-md-12 row">
        <div class="col-md-5">
            <label for="">Nombre del representante legal</label><span class="is-invalid">*</span>
            <input class="form-control" type="text" v-model="nombre_representante_legal" required/>
        </div>
        <div class="col-md-5">
            <label for="">Denominación o Razón social</label><span class="is-invalid">*</span>
            <input class="form-control" type="text" v-model="razon_social" required/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Número de Escritura Pública del acta constitutiva.</label>
            <input class="form-control" type="text" v-model="numero_escritura_publica_acta_const" />
        </div>
        <div class="col-md-4">
            <label for="">Fecha de Constitución</label><span class="is-invalid">*</span>
            <input class="form-control" type="date" v-model="fecha_constitucion" required>
        </div>
        <div class="col-md-4">
            <label for="">Nombre Federatario Publico</label>
            <input class="form-control" type="text" v-model="nombre_federatorio_publico"/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Número Federatario</label>
            <input class="form-control" type="text" v-model="numero_federatorio"/>
        </div>
        <div class="col-md-4">
            <label for="">Lugar de Adscripción Del Federatario Público</label>
            <input class="form-control" type="text" v-model="lugar_adscripcion_federatorio_publico"/>
        </div>
        <div class="col-md-4">
            <label for="">Escritura Pública del acta constitutiva</label>
            <input type="file"   @change="event => onFileChangeSubir(event, 'imageFile2Escritura', 'ImagenPrevia')" accept="application/pdf" class="form-control"/>
        </div>
       
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
           
        </div>
        <div class="col-md-4">
           
        </div>
        <div class="col-md-4">
            <div v-if="imagePreviewEscritura" class="col-md-4 text-center">
                <iframe  :src=" imagePreviewEscritura" width="300" height="150" ></iframe>
                <!--<img :src="imagePreviewEscritura" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">-->
            </div>
            
        </div>
        
    </div>
   
        <div class="col-md-2">

        </div>
        <div class="col-md-12 row" >
            <div  class="col-md-4" >
                
        
            </div>
            <div  class="col-md-4" >
                
        
            </div>
           
            <div v-if="imagePreviewEscritura " class="col-md-4 text-center" >
                <button type="button" class="btn btn-outline-warning" @click="downloadPDF(imagePreviewEscritura)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
                <button type="button" class="btn btn-outline-danger" @click="eliminar_escritura_publicaActaConstitutiva()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>
        
            </div>
        </div>
       
    
    
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Nombre del apoderado para la firma del contrato(Manual)</label>
            <input class="form-control" type="text" v-model="nombre_apoderado_firma_contratoManual"/>
        </div>
        <div class="col-md-4">
            <label for="">Identificación oficial apoderado legal para firma de contrato</label>
            <input type="file"   @change="event => onFileChangeSubir(event, 'imageFileApoderado', 'ImagenPrevia2')" accept="application/pdf" class="form-control"/><br>
            <div v-if="imagePreviewApoderado" class="text-center">
                <!--<img :src="imagePreviewApoderado" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">-->
                <iframe  :src=" imagePreviewApoderado" width="300" height="150" ></iframe>
            </div>
           

        </div>
        <div class="col-md-4">
            <label for="">Número de Escritura Pública del Poder del representante para la firma del contrato(Manual)</label>
            <input class="form-control" type="text" v-model="numero_escritura_publica"/>
        </div>
    </div>
    <div class="col-md-12 row" >
        <div  class="col-md-4" >
            
    
        </div>
        <div v-if="imagePreviewApoderado " class="col-md-4 text-center" >
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(imagePreviewApoderado)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>
    
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-5">
            <label for="">Escritura Pública del Poder del representante para la firma del contrato</label>
           
            <input type="file" @change="event => onFileChangeSubir(event, 'imageFile3EscroturaPub', 'ImagenPrevia3')" class="form-control" accept="application/pdf"/>
            <div v-if="imagePreviewEscroturaPub" class="text-center">
                <iframe  :src=" imagePreviewEscroturaPub" width="300" height="150" ></iframe>
                <!--<img :src="imagePreviewEscroturaPub" alt="Vista previa de la imagen" id="imagencat" width="150" @click="eliminarImagen()">-->
            </div>
        </div>
    
    </div>

    <div class="py-3 col-md-12 row">
        <div v-if="imagePreviewEscroturaPub " class="col-md-5 text-center" >
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(imagePreviewEscroturaPub)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>
    
        </div>
    
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Fecha de otorgamiento del poder</label><span class="is-invalid">*</span>
            <input class="form-control" type="date" v-model="fecha_otorgamiento_poder" required/>
        </div>
        <div class="col-md-4">
            <label for="">Nombre Fedatario Público</label>
            <input class="form-control" type="text" v-model="nombre_fedatario_publico"/>
        </div>
        <div class="col-md-4">
            <label for="">Número Fedatario Público</label>
            <input class="form-control" type="text" v-model="numero_fedetario_publico"/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Lugar de Adscripción del Fedatario Público</label>
            <input class="form-control" type="text" v-model="lugar_adscripcion_federatario_publico"/>
        </div>
        
    </div>

    <hr>
    
    <div class="col-md-12" id="botonespersonaMoral" style="display: block;">
        <button v-if="existenDatosRegistradosMoral == false" type="button" class="btn"  style="background-color: #F49315; color: white;" @click="guardarpersonamoral">Guardar datos de propietario</button>
        <button v-if="existenDatosRegistradosMoral == true" type="button" class="btn btn-warning" @click="actualizarpersonamoral">Actualizar datos de propietario</button>
    
    </div>
</div>


<div style="display:block" id="personaFisica">
    <div class="py-3 col-md-12 row">
        <div class="col-md-5">
            <label for="">Nombre</label><span class="is-invalid">*</span>
            <input class="form-control" type="text" v-model="nombre"/>
        </div>
        <div class="col-md-5">
            <label for="">Email</label><span class="is-invalid">*</span>
            <input class="form-control" type="text" v-model="email"/>
        </div>
        <div class="col-md-5">
            <label for="">Telefono</label>
            <input class="form-control" type="text" v-model="telefono"/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-4">
            <label for="">Tipo de indentificacion</label>
           
            <select
                class="form-control"
                v-model="tipo_identificacion"
                @change="actualizarExpide"
            >
                <option value="">Seleccione una identificación</option>
                <option value="CREDENCIAL PARA VOTAR">CREDENCIAL PARA VOTAR</option>
                <option value="PASAPORTE">PASAPORTE</option>
                <option value="CURP">CURP</option>
            </select>
        </div>
        <div class="col-md-4">
            <label for="">Expedida por</label>
            <input class="form-control" type="text" v-model="expendidaPor" readonly/>
        </div>
        <div class="col-md-4">
            <label for="">Numero</label>
            <input class="form-control" type="text" v-model="numero_ine"/>
        </div>
        <!--<div class="col-md-4">
            <label for="">Curp</label>
            <input class="form-control" type="text" v-model="curp"/>
        </div>-->
        <div class="col-md-4">
    <label for="curp" class="form-label">
        CURP <span class="text-danger">*</span>
    </label>

    <input
        id="curp"
        name="curp"
        class="form-control"
      
        type="text"
        v-model.trim="curp"
        @input="curp = curp.toUpperCase()"
        maxlength="18"
        minlength="18"
        pattern="[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[A-Z0-9][0-9]"
        placeholder="Ingresa tu CURP"
        title="La CURP debe tener 18 caracteres"
        autocomplete="off"
        required
    />

   

    <small class="text-muted">
        Debe contener 18 caracteres.
    </small>
</div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-8">
            <label for="">Identificación con CURP de la persona física Tamaño máximo 5 MB</label>
            <input type="file" @change="onFileChange($event, 'imageFile')" accept="application/pdf" class="form-control"/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-5">
           <div v-if="imagePreview" class="text-center">
                <!--<img :src="imagePreview" alt="Vista previa de la imagen" id="imagencat" width="200" @click="eliminarImagen()">-->
                <iframe  :src=" imagePreview" width="300" height="150" id="imagencat" ></iframe>
            </div>
        </div>
        
    </div>
    <div v-if="imagePreview" class="col-md-5">
        <button type="button" class="btn btn-outline-warning" @click="downloadPDF(imagePreview)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
        <button type="button" class="btn btn-outline-danger" @click="eliminar_curp()" > <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-6">
            <label for="">Identificación oficial del apoderado para la firma del contrato(manual)</label>
            <input class="form-control" type="text" v-model="nombreApoderado"/>
        </div>
        <div class="col-md-6">
            <label for="">Identificación oficial del apoderado para la firma del contrato Tamaño máximo 5 MB</label>
            <input type="file" @change="onFileChangeApoderado($event, 'imageFile2')" accept="application/pdf" class="form-control"/>
        </div>
    </div>
    <div class="py-3 col-md-12 row">
        <div class="col-md-6">
            
        </div>
        <div class="col-md-6">
            <div v-if="imagePreview2" class="text-center">
                <!--<img :src="imagePreview2" alt="Vista previa de la imagen" id="imagencat" width="200" @click="eliminarImagen()">-->
                <iframe  :src=" imagePreview2" width="300" height="150" id="imagencat" @click="eliminarImagen()"></iframe>

            </div>
        </div>
        <div v-if="imagePreview2" class="col-md-10" style="text-align: right;">
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(imagePreview2)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger" @click="eliminar_identificacion()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

        </div>
    </div>
</div>
<div class="col-md-12" id="botonespersonaFisica" style="display: block;">
    <button v-if="existenDatosRegistrados == false" type="button" class="btn" style="background-color: #F49315; color: white;" @click="guardar">Guardar datos de propietario</button>
    <button v-if="existenDatosRegistrados == true" type="button" class="btn btn-warning" @click="actualizar">Actualizar datos de propietario</button>

</div>
</template>
<script>
import Swal from 'sweetalert2';
import axios from 'axios';
export default {
    data() {
        return {
            isLoading:false,
            isButton1Disabled: false,
            isButton2Disabled: true,
            nombre:'',
            email:'',
            telefono:'',
            tipo_identificacion:'',
            expendidaPor:'',
            numero_ine:'',
            curp:'',
            curp_imagen:'',
            nombreApoderado:'',
            nombreApoderado_imagen:'',
            usuario:'',
            imageFile:null,
            imageFile2:null,
            imagePreview:null,
            imagePreview2:null,
            existenDatosRegistrados:false,
            id:'',
            /*Persona Moral*/
            nombre_representante_legal:'',
            razon_social:'',
            numero_escritura_publica_acta_const:'',
            fecha_constitucion:'',
            nombre_federatorio_publico:'',
            numero_federatorio:'',
            lugar_adscripcion_federatorio_publico:'',
            escritura_publica_acta_constitutiva:'',
            nombre_apoderado_firma_contratoManual:'',
            nombre_apoderado_firma_contrato_imagen:'',
            numero_escritura_publica:'',
            numero_escritura_publica_imagen:'',
            fecha_otorgamiento_poder:'',
            nombre_fedatario_publico:'',
            numero_fedetario_publico:'',
            lugar_adscripcion_federatario_publico:'',
            imageFileApoderado:null,
            imageFile2Escritura:null,
            imageFile3EscroturaPub:null,
            imagePreviewApoderado:null,
            imagePreviewEscritura:null,
            imagePreviewEscroturaPub:null,
            existenDatosRegistradosMoral:false,
            idPersonaMoral:''


        }  
    },
    created() {
        this.consultarInformacion();
        this.consultarPersonasMorales();
    },
    methods: {
        validarCurp() {
            // Convertir a mayúsculas y quitar espacios
            this.curp = this.curp
                .toUpperCase()
                .trim();

            const curp = this.curp;

            // Si está vacío
            if (!curp) {
                this.errorCurp = 'La CURP es obligatoria.';
                return false;
            }

            // Validar estructura general de la CURP
            const regexCurp =
                /^[A-Z]{4}\d{6}[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]\d$/;

            if (curp.length !== 18) {
                this.errorCurp = 'La CURP debe tener exactamente 18 caracteres.';
                return false;
            }

            if (!regexCurp.test(curp)) {
                this.errorCurp = 'La estructura de la CURP no es válida.';
                return false;
            }

            this.errorCurp = '';
            return true;
        },
        actualizarExpide() {
            const expedidoPor = {
                'CREDENCIAL PARA VOTAR': 'INE',
                'PASAPORTE': 'SER',
                'CURP': 'SEGOB',
            };

            this.expendidaPor = expedidoPor[this.tipo_identificacion] || '';
        },
        downloadPDF(descargar) {
            
            const pdfUrl = descargar;
            // Abrir el PDF en una nueva pestaña
            window.open(pdfUrl, '_blank');
        },
        selectButton(buttonNumber) {
            if (buttonNumber === 1) {
                this.isButton2Disabled = true;
                this.isButton1Disabled = false;
                document.getElementById('personaMoral').style.display = 'none';
                document.getElementById('personaFisica').style.display = 'block';
                document.getElementById('botonespersonaFisica').style.display = 'block';
                document.getElementById('botonespersonaMoral').style.display = 'none';


            } else if (buttonNumber === 2) {
                
                this.isButton1Disabled = true;
                this.isButton2Disabled = false;
                document.getElementById('personaMoral').style.display = 'block';
                document.getElementById('personaFisica').style.display = 'none';
                document.getElementById('botonespersonaFisica').style.display = 'none';
                document.getElementById('botonespersonaMoral').style.display = 'block';
                



            }
        },
            //subir imagen
        onFileChange(event) {
            const file = event.target.files[0];
            if (file && file.type === 'application/pdf') {
                this.imageFile = file;
                this.previewPDF(file); // Función para previsualizar el PDF
            } else {
                this.imageFile = null;
                this.imagePreview = null; // Borra la previsualización si no es un PDF
            }
        },
        previewPDF(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        onFileChangeApoderado(event) {
            /*const file = event.target.files[0];
            if (file && file.type.startsWith('image/')) {
                this.imageFile2 = file;
                this.previewImageApoderado(file);
            } else {
                this.imageFile = null;
                this.imagePreview = null;
            }*/

            const file = event.target.files[0];
            if (file && file.type === 'application/pdf') {
                this.imageFile2 = file;
                this.previewImageApoderado(file); // Función para previsualizar el PDF
            } else {
                this.imageFile2 = null;
                this.imagePreview = null; // Borra la previsualización si no es un PDF
            }
        },
        previewImageApoderado(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreview2 = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        async guardar(){
            const formData = new FormData();
            var idcotizacion = localStorage.getItem('idcotizacion');
            formData.append('nombre', this.nombre);
            formData.append('email', this.email);
            formData.append('telefono', this.telefono);
            formData.append('image', this.image);
            formData.append('tipo_identificacion', this.tipo_identificacion);
            formData.append('expendidaPor', this.expendidaPor);
            formData.append('numero_ine', this.numero_ine);
            formData.append('curp', this.curp);
            formData.append('curp_imagen', this.curp_imagen);
            formData.append('nombreApoderado', this.nombreApoderado);
            formData.append('idcotizacion', idcotizacion);
            formData.append('usuario', localStorage.getItem('email'));
       


            if(this.imageFile){
                formData.append('curp_imagen', this.imageFile);
            }
            if(this.imageFile2){
                formData.append('nombreApoderado_imagen', this.imageFile2);
            }
            
        try {
            const response = await fetch(this.$rutaServer+'personasfisicas', {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if(response.status == 201){
                Swal.fire('¡Éxito!', 'Datos registrados', 'success');
            }
            else{
                console.log(data);
                if(data.errors){
                    var msj = data.errors.email[0];
                    Swal.fire('¡Error!',msj , 'error');
                }
                if (data.errors) {
                    console.log(data.errors.curp_imagen);
                    if(data.errors?.curp_imagen?.[0]){
                        var msj = data.errors.curp_imagen[0];
                        Swal.fire('¡Error!',msj , 'error');
                    }
                    if(data.errors?.nombreApoderado_imagen?.[0]){
                        var msjapo = data.errors.nombreApoderado_imagen[0];
                        Swal.fire('¡Error!',msjapo , 'error');
                    }
                } else {
                    console.log(data);
                }
            }
        } catch (error) {
            alert(error);
            console.log(error.response.data+'aqui');
           // Swal.fire('Error!', 'Ocurrio un error', 'error');
            if(error.response.data.errors?.nombre?.[0]){
                    this.validation.nombre= error.response.data.errors.nombre[0];
            }
            if(error.response.data.errors?.email?.[0]){
                    this.validation.email = error.response.data.errors.email[0];
            }
            

            /*if(error.response.data.errors?.curp_imagen?.[0]){
                Swal.fire('Error!', 'La curp no debería pesar más de 5 MB', 'error');
            }*/
           
            //console.error(error);
        }
        },
        consultarInformacion(){
            
            this.isLoading = true;
            var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'consultarInformacion', { idcotizacion: idcotizacion })
            .then(response => {
                console.log(this.$rutaImagenes+response.data[0].curp_imagen);
                if (response.status == 200) {
                this.isLoading = false;
                if(response.data.length > 0){
                    this.existenDatosRegistrados = true;
                }
                //this.datos = response.data.data[0];
                this.nombre = response.data[0].nombre;
                this.email = response.data[0].email;
                this.telefono = response.data[0].telefono;
                this.tipo_identificacion = response.data[0].tipo_identificacion;
                this.expendidaPor = response.data[0].expendidaPor;
                this.numero_ine = response.data[0].numero_ine;
                this.curp = response.data[0].curp;
                this.nombreApoderado = response.data[0].nombreApoderado;
                this.id= response.data[0].id;
            //nombreApoderado_imagen:'',
                if(response.data[0].curp_imagen){
                    this.imagePreview = this.$rutaImagenes+response.data[0].curp_imagen;
                }
                if(response.data[0].nombreApoderado_imagen){
                    this.imagePreview2 = this.$rutaImagenes+response.data[0].nombreApoderado_imagen;
                }
                
                
                //console.log(this.datos);
                }
          })
          .catch(error => {
            //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          }
        ).finally(() => {
            this.isLoading = false;
        });
        },
        async eliminar_curp(){
        const token = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
            }
        };
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Confirma eliminar archivo curp!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
        
        var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'eliminarcurp_fisica',{idcotizacion: idcotizacion },config)
            .then(response => {
                if(response.status == 200){
                    this.consultarInformacion();
                    this.imagePreview = '';
                    Swal.fire('¡Éxito!', 'Archivo CURP eliminado', 'success');
                    
                }
            })
            .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        }
                
        },
        async eliminar_identificacion(){
        const token = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
            }
        };
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Confirma eliminar archivo de identificacion!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
        
        var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'eliminaridentificacionapoderado_fisica',{idcotizacion: idcotizacion },config)
            .then(response => {
                if(response.status == 200){
                    this.consultarInformacion();
                    this.imagePreview2 = '';
                    Swal.fire('¡Éxito!', 'Archivo de Identificacion eliminado', 'success');
                    
                }
            })
            .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        }
                
        },
        async eliminar_escritura_publicaActaConstitutiva(){
        const token = localStorage.getItem('accessToken');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                Accept:'application/json'
            }
        };
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¡Confirma eliminar archivo de escritura pública!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (result.isConfirmed) {
        
        var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'eliminarescriturapublica_moral',{idcotizacion: idcotizacion },config)
            .then(response => {
                if(response.status == 200){
                    this.consultarInformacion();
                    this.imagePreview2 = '';
                    Swal.fire('¡Éxito!', 'Archivo de Escritura Pública fue eliminado', 'success');
                    
                }
            })
            .catch(error => {
                Swal.fire('¡Error!', 'Ocurrio un error ','error');
            });
        }
                
        },
        async actualizar(){

            // Convertir a mayúsculas y quitar espacios
            this.curp = this.curp
                .toUpperCase()
                .trim();

            const curp = this.curp;

            // Si está vacío
            if (!curp) {
                this.errorCurp = 'La CURP es obligatoria.';
                return false;
            }

            // Validar estructura general de la CURP
            const regexCurp =
                /^[A-Z]{4}\d{6}[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]\d$/;

            if (curp.length !== 18) {
                //this.errorCurp = 'La CURP debe tener exactamente 18 caracteres.';
                Swal.fire('Error!', 'La CURP debe tener exactamente 18 caracteres.', 'error');
                return false;
            }

            if (!regexCurp.test(curp)) {
                Swal.fire('Error!', 'La estructura de la CURP no es válida.', 'error');
                return false;
            }
            const formData = new FormData();
            var idcotizacion = localStorage.getItem('idcotizacion');
            formData.append('nombre', this.nombre);
            formData.append('email', this.email);
            formData.append('telefono', this.telefono);
            formData.append('image', this.image);
            formData.append('tipo_identificacion', this.tipo_identificacion);
            formData.append('expendidaPor', this.expendidaPor);
            formData.append('numero_ine', this.numero_ine);
            formData.append('curp', this.curp);
            formData.append('curp_imagen', this.curp_imagen);
            formData.append('nombreApoderado', this.nombreApoderado);
            formData.append('idcotizacion', idcotizacion);
            formData.append('usuario', localStorage.getItem('email'));
            formData.append('id', this.id);
       


            if(this.imageFile){
                formData.append('curp_imagen', this.imageFile);
            }
            if(this.imageFile2){
                formData.append('nombreApoderado_imagen', this.imageFile2);
            }
            
        try {
            const response = await fetch(this.$rutaServer+'actualizarDatosRepresentante', {
                method: 'POST',
                body: formData,
            });
            if(response.status == 200){
                Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                this.consultarInformacion();
            }
        } catch (error) {
           // Swal.fire('Error!', 'Ocurrio un error', 'error');
            if(error.response.data.errors?.nombre?.[0]){
                    this.validation.nombre= error.response.data.errors.nombre[0];
            }
            if(error.response.data.errors?.email?.[0]){
                    this.validation.email = error.response.data.errors.email[0];
            }
            //console.error(error);
        }
        },
        /*Persona Moral*/
        
        async guardarpersonamoral(){
            const formData = new FormData();
            var idcotizacion = localStorage.getItem('idcotizacion');
            formData.append('nombre_representante_legal', this.nombre_representante_legal);
            formData.append('razon_social', this.razon_social);
            formData.append('numero_escritura_publica_acta_const', this.numero_escritura_publica_acta_const);
            formData.append('fecha_constitucion', this.fecha_constitucion);
            formData.append('nombre_federatorio_publico', this.nombre_federatorio_publico);
            formData.append('numero_federatorio', this.numero_federatorio);
            formData.append('lugar_adscripcion_federatorio_publico', this.lugar_adscripcion_federatorio_publico);
        //formData.append('numero_escritura_publica_acta_const', this.numero_escritura_publica_acta_const);
            formData.append('nombre_apoderado_firma_contratoManual', this.nombre_apoderado_firma_contratoManual);
            formData.append('numero_escritura_publica', this.numero_escritura_publica);
            formData.append('fecha_otorgamiento_poder', this.fecha_otorgamiento_poder);
            formData.append('nombre_fedatario_publico', this.nombre_fedatario_publico);
            formData.append('numero_fedetario_publico', this.numero_fedetario_publico);
            formData.append('lugar_adscripcion_federatario_publico', this.lugar_adscripcion_federatario_publico);
            formData.append('idcotizacion', idcotizacion);
       


            if(this.imageFileApoderado){
                formData.append('nombre_apoderado_firma_contrato_imagen', this.imageFileApoderado);
            }
            if(this.imageFile2Escritura){ 
                formData.append('escritura_publica_acta_constitutiva', this.imageFile2Escritura);
            }

            if(this.imageFile3EscroturaPub){
                formData.append('numero_escritura_publica_imagen', this.imageFile3EscroturaPub);
            }
            
        try {
            const response = await fetch(this.$rutaServer+'guardarPersonasMorales', {
                method: 'POST',
                body: formData,
            });
             const data = await response.json();

    console.log(data);
            if(response.status == 201){
                Swal.fire('¡Éxito!', 'Datos registrados', 'success');
            }
        } catch (error) {
            console.log(error);
           // Swal.fire('Error!', 'Ocurrio un error', 'error');
            if(error.response.data.errors?.nombre?.[0]){
                    this.validation.nombre= error.response.data.errors.nombre[0];
            }
            if(error.response.data.errors?.email?.[0]){
                    this.validation.email = error.response.data.errors.email[0];
            }
            if(error.response.data.errors?.nombre_apoderado_firma_contrato_imagen?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.nombre_apoderado_firma_contrato_imagen[0], 'error');
                   
            }
            if(error.response.data.errors?.numero_escritura_publica_imagen?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.numero_escritura_publica_imagen[0], 'error');
                   
            }
            if(error.response.data.errors?.escritura_publica_acta_constitutiva?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.escritura_publica_acta_constitutiva[0], 'error');
                   
            }
        }
        },
        onFileChangeSubir(event, imageFileKey, previewFunction) {
            const file = event.target.files[0];
            if (file && file.type.startsWith('application/pdf')) {
                this[imageFileKey] = file;
                this[previewFunction](file);
            } else {
                this[imageFileKey] = null;
                this.imagePreview = null;
            }
        },
        ImagenPrevia(file){
            
            //this.fileURL = URL.createObjectURL(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreviewEscritura = e.target.result;
                
            };
            reader.readAsDataURL(file);
        },
        ImagenPrevia2(file){
            
            //this.fileURL = URL.createObjectURL(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreviewApoderado = e.target.result;

            };
            reader.readAsDataURL(file);
        },
        ImagenPrevia3(file){
            const reader = new FileReader();
            reader.onload = (e) => {
                this.imagePreviewEscroturaPub = e.target.result;

            };
            reader.readAsDataURL(file);
        },
        consultarPersonasMorales(){
            this.isLoading = true;
            var idcotizacion = localStorage.getItem('idcotizacion');
            axios.post(this.$rutaServer+'consultarPersonasMorales', { idcotizacion: idcotizacion })
            .then(response => {
                if (response.status == 200) {
                this.isLoading = false;
                if(response.data.length > 0){
                    this.existenDatosRegistradosMoral = true;
                }
                
                //this.datos = response.data.data[0];
                this.nombre_representante_legal = response.data[0].nombre_representante_legal;
                this.razon_social = response.data[0].razon_social;
                this.fecha_constitucion = response.data[0].fecha_constitucion;
                this.nombre_federatorio_publico = response.data[0].nombre_federatorio_publico;
                this.numero_federatorio = response.data[0].numero_federatorio;
                this.lugar_adscripcion_federatorio_publico = response.data[0].lugar_adscripcion_federatorio_publico;
                this.escritura_publica_acta_constitutiva = response.data[0].escritura_publica_acta_constitutiva;
                this.nombre_apoderado_firma_contratoManual = response.data[0].nombre_apoderado_firma_contratoManual;
                this.numero_escritura_publica = response.data[0].numero_escritura_publica;
                this.fecha_otorgamiento_poder = response.data[0].fecha_otorgamiento_poder;
                this.nombre_fedatario_publico = response.data[0].nombre_fedatario_publico;
                this.numero_fedetario_publico = response.data[0].numero_fedetario_publico;
                this.lugar_adscripcion_federatario_publico = response.data[0].lugar_adscripcion_federatario_publico;
                this.idPersonaMoral = response.data[0].id;
                this.numero_escritura_publica_acta_const = response.data[0].numero_escritura_publica_acta_const;

            //nombreApoderado_imagen:'',
                if(response.data[0].nombre_apoderado_firma_contrato_imagen){
                    this.imagePreviewApoderado = this.$rutaImagenes+response.data[0].nombre_apoderado_firma_contrato_imagen;
                }
                if(response.data[0].numero_escritura_publica_imagen){
                    this.imagePreviewEscritura = this.$rutaImagenes+response.data[0].numero_escritura_publica_imagen;
                }

                if(response.data[0].escritura_publica_acta_constitutiva){
                    this.imagePreviewEscroturaPub = this.$rutaImagenes+response.data[0].escritura_publica_acta_constitutiva;
                } 
               
               
                //console.log(this.datos);
                }
          })
          .catch(error => {
            //Swal.fire('¡Error!', 'Ocurrió un error', 'error');
          });
        },
        async actualizarpersonamoral(){
            const formData = new FormData();
           // alert('aqui');
            var idcotizacion = localStorage.getItem('idcotizacion');
            formData.append('nombre_representante_legal', this.nombre_representante_legal);
            formData.append('razon_social', this.razon_social);
            formData.append('numero_escritura_publica_acta_const', this.numero_escritura_publica_acta_const);

            //formData.append('numero_escritura_publica_acta_const', this.numero_escritura_publica_acta_const);
            formData.append('fecha_constitucion', this.fecha_constitucion);
            formData.append('nombre_federatorio_publico', this.nombre_federatorio_publico);
            formData.append('numero_federatorio', this.numero_federatorio);
            formData.append('lugar_adscripcion_federatorio_publico', this.lugar_adscripcion_federatorio_publico);
            //formData.append('escritura_publica_acta_constitutiva', this.escritura_publica_acta_constitutiva);
            formData.append('nombre_apoderado_firma_contratoManual', this.nombre_apoderado_firma_contratoManual);
            formData.append('numero_escritura_publica', this.numero_escritura_publica);
            formData.append('fecha_otorgamiento_poder', this.fecha_otorgamiento_poder);
            formData.append('nombre_fedatario_publico', this.nombre_fedatario_publico);
            formData.append('numero_fedetario_publico', this.numero_fedetario_publico);
            formData.append('lugar_adscripcion_federatario_publico', this.lugar_adscripcion_federatario_publico);
            formData.append('idpersonamoral', this.idPersonaMoral);
            formData.append('idcotizacion', idcotizacion);


          


            if(this.imageFileApoderado){
                formData.append('nombre_apoderado_firma_contrato_imagen', this.imageFileApoderado);
            }
            /*if(this.imageFile2Escritura){ 
                alert('aqui');
                formData.append('escritura_publica_acta_constitutiva', this.imageFile2Escritura);
            }*/
            if(this.imageFile3EscroturaPub){ 
               // alert('aqui');
                formData.append('escritura_publica_acta_constitutiva', this.imageFile3EscroturaPub);
            }
//alert(this.imageFile3EscroturaPub);
//console.log(this.imageFile2Escritura);
            if(this.imageFile2Escritura){
                formData.append('numero_escritura_publica_imagen', this.imageFile2Escritura);
            }
            
        try {
            const response = await fetch(this.$rutaServer+'actualizarPersonasMorales', {
                method: 'POST',
                body: formData,
            });
            if(response.status == 200){
                Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
            }
        } catch (error) {
           // Swal.fire('Error!', 'Ocurrio un error', 'error');
            if(error.response.data.errors?.nombre?.[0]){
                    this.validation.nombre= error.response.data.errors.nombre[0];
            }
            if(error.response.data.errors?.email?.[0]){
                    this.validation.email = error.response.data.errors.email[0];
            }

            if(error.response.data.errors?.nombre_apoderado_firma_contrato_imagen?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.nombre_apoderado_firma_contrato_imagen[0], 'error');
                   
            }
            if(error.response.data.errors?.numero_escritura_publica_imagen?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.numero_escritura_publica_imagen[0], 'error');
                   
            }
            if(error.response.data.errors?.escritura_publica_acta_constitutiva?.[0]){
                Swal.fire('¡Error!', error.response.data.errors.escritura_publica_acta_constitutiva[0], 'error');
                   
            }
            //console.error(error);
        }
        },
    },
        
};
</script>
<style>
    .is-invalid {
        color: red;
    }
</style>